import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  TEXT_TO_SPEECH_MAX_TEXT_LENGTH,
  TEXT_TO_SPEECH_MAX_NAME_LENGTH,
  getRandomInt,
  AUDIO_DEFAULT_NAME_PREFIX,
  isInputEmpty,
} from '../../utils';

export const useAudioForm = () => {
  const FormSchema = Yup.object().shape({
    text: Yup.string()
      .required('Text is required')
      .test('not-empty', 'Text is required', (value) => !isInputEmpty(value))
      .max(
        TEXT_TO_SPEECH_MAX_TEXT_LENGTH,
        `Text must be at most ${TEXT_TO_SPEECH_MAX_TEXT_LENGTH} characters`
      )
      .typeError('Text must be a valid string'),
    name: Yup.string()
      .required('Name is required')
      .test('not-empty', 'Name is required', (value) => !isInputEmpty(value))
      .max(
        TEXT_TO_SPEECH_MAX_NAME_LENGTH,
        `Name must be at most ${TEXT_TO_SPEECH_MAX_NAME_LENGTH} characters`
      )
      .typeError('Name must be a valid string'),
  });

  const formMethods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: { text: '', name: AUDIO_DEFAULT_NAME_PREFIX + getRandomInt(1, 1000) },
    mode: 'onChange',
  });

  return formMethods;
};
